import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

let headings = Array.from(
	document.querySelectorAll('.offering-headings .offering-heading'),
);

let parentContainer = document.querySelector('.offering-container');
let currentActive;

const swiper = new Swiper('.offering-details', {
	speed: 400,
	modules: [Autoplay],
	autoplay: {
		delay: 5000,
		pauseOnMouseEnter: true,
		waitForTransition: true,
	},
	breakpoints: {
		1050: {
			spaceBetween: 50,
		},
	},
	on: {
		init: function () {
			currentActive = headings[this.activeIndex];
			currentActive.classList.add('active-offering');
		},
	},
});

swiper.on('autoplayTimeLeft', function (a, b, percentage) {
	parentContainer.style.setProperty(
		'--active-width',
		`${100 - percentage * 100}%`,
	);
});

headings.forEach((element) => {
	element.addEventListener('click', (event) => {
		swiper.slideTo(event.target.dataset.id, 500);
	});
});

swiper.on('slideChange', function () {
	currentActive.classList.remove('active-offering');
	currentActive = headings[this.activeIndex];
	currentActive.classList.add('active-offering');
});
